// extracted by mini-css-extract-plugin
export default {"container":"PhoneNumber_container__n4ozn","progressContainer":"PhoneNumber_progressContainer__gRHDr","inputRoot":"PhoneNumber_inputRoot__Z9fC3"};